import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import CrudDashboard from './crud-dashboard/CrudDashboard';
import LandingPage from './components/LandingPage';

const AppWithLanding = () => {
  const [showLanding, setShowLanding] = useState(true);

  const handleAnimationComplete = () => {
    setShowLanding(false);
  };

  return (
    <>
      {showLanding && <LandingPage onAnimationComplete={handleAnimationComplete} />}
      <CrudDashboard />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppWithLanding />
);

// Register Firebase service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Firebase Service Worker registered:', registration);
    })
    .catch((error) => {
      console.error('Firebase Service Worker registration failed:', error);
    });
}

reportWebVitals();
